/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = {
  scheduleDate: null,
  scheduleSource: null,
  currentTimeShiftProgram: null,
  currentExportProgram: null,
};

const getters = {
  shouldShowTimeShiftModal: state => state.currentTimeShiftProgram !== null,
  shouldShowExportModal: state => state.currentExportProgram !== null,
};

const mutations = {
  setCurrentTimeShiftProgram(state, program) {
    state.currentTimeShiftProgram = program;
  },
  setCurrentExportProgram(state, program) {
    state.currentExportProgram = program;
  },
  setScheduleDate(state, date) {
    state.scheduleDate = date;
  },
  setScheduleSource(state, source) {
    state.scheduleSource = source;
  },
  resetCurrentExportProgram(state) {
    state.currentExportProgram = null;
  },
  resetCurrentTimeShiftProgram(state) {
    state.currentTimeShiftProgram = null;
  },
};

const actions = {
  setCurrentTimeShiftProgram({ commit }, program) {
    commit('setCurrentTimeShiftProgram', program);
  },
  setCurrentExportProgram({ commit }, program) {
    commit('setCurrentExportProgram', program);
  },
  resetCurrentTimeShiftProgram({ commit }) {
    commit('resetCurrentTimeShiftProgram');
  },
  resetCurrentExportProgram({ commit }) {
    commit('resetCurrentExportProgram');
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
